import React from "react";

const Library = () => {
	return <div></div>;
};

export default Library;
